import property from 'lodash/property';
import { createSelector } from 'reselect';

import getParent from '../selectors';

export const getPrimaryParameter = state =>
  getParent(state).primaryParameter;

export const getPrimaryParameterName = createSelector(
  getPrimaryParameter, property('name')
);

export const getPrimaryParameterType = createSelector(
  getPrimaryParameter, property('type')
);

export const getPrimaryParameterValues = createSelector(
  getPrimaryParameter, property('values')
);

export default getPrimaryParameter;
